export default __webpack_public_path__ + "static/media/mining-expiration.63f75cd0.svg";